import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import getLocale from "/utils/locale";
import TrialDurationExplanation from "/features/trial-duration-explanation/components/trial-duration-explanation";

const container = document.querySelector(".js-trial-duration-explanation");

const init = (container) => {
  if (!container) return;

  const {
    ctaCopy,
    ctaJsClass,
    piwikCategory,
    subscriptionPlan
  } = container.dataset;

  new Vue({
    el: container,
    i18n: new VueI18n({ locale: getLocale() }),
    render: h => h(TrialDurationExplanation, {
      props: {
        ctaCopy,
        ctaJsClass,
        piwikCategory,
        subscriptionPlan: JSON.parse(subscriptionPlan)
      }
    })
  });
};

init(container);
